import * as fetchDemographicsDataHelper from './fetchDemographicsData';

export default {
    ...fetchDemographicsDataHelper,
};